import { provideHttpClient } from "@angular/common/http";
import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling // 👈 1. Importar esto
} from "@angular/router";

import { SharedModule } from "./shared/shared.module";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),

    // 👇 2. Agregar withInMemoryScrolling aquí
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      })
    ),

    provideHttpClient(),
    importProvidersFrom(SharedModule),

    {
      provide: FaIconLibrary,
      useFactory: () => {
        const library = new FaIconLibrary();
        library.addIcons(faWhatsapp);
        library.addIconPacks(fas);
        return library;
      },
      deps: []
    },
  ]
};